<header class="header white-bg">
          <div class="sidebar-toggle-box" *ngIf="isLoggedIn()"  >
              <div data-original-title="Toggle Navigation" data-placement="right" class="fa fa-bars tooltips"  (click)="sideNavService.toggleSideNav()"></div>
          </div>
          <!--logo start-->
          <a href="index.html" class="logo" ><img src="assets/img/logo.png" style="margin: 5px 0 5px 12px;" class=""  border="0"></a>
          <!--logo end-->

          <a href="login" class="logout"><i class="fa fa-key"></i> Log Out</a>
          <!-- <div class="nav notify-row"  id="top_menu" *ngIf="isLoggedIn()" >
            <ul class="nav top-menu" >
              <li id="header_notification_bar" class="dropdown">
                  <a data-toggle="dropdown" class="dropdown-toggle" href="#">
                      <i class="fa fa-bell-o"></i>
                      <span class="badge bg-primary">7</span>
                  </a>
                  <ul class="dropdown-menu extended notification">
                      <div class="notify-arrow notify-arrow-yellow"></div>
                      <li>
                          <p class="primary">You have 3 new notifications</p>
                      </li>
                      <li>
                          <a href="#">
                              <span class="label label-danger"><i class="fa fa-bolt"></i></span>
                              John Doe Has Clicked Your order.<br/>
                              <span class="small italic">34 mins</span>
                          </a>
                      </li>
                      <li>
                          <a href="#">
                              <span class="label label-warning"><i class="fa fa-bell"></i></span>
                              John Doe Has Confirmed Your order. <br/>
                              <span class="small italic">1 Hours</span>
                          </a>
                      </li>
                      <li>
                          <a href="#">
                              <span class="label label-danger"><i class="fa fa-bolt"></i></span>
                              Bryan Harris Has Clicked Your order..<br/>
                              <span class="small italic">4 hrs</span>
                          </a>
                      </li>
                      
                      <li>
                          <a href="#">See all notifications</a>
                      </li>
                  </ul>
              </li>
          </ul>
          </div>
          <div class="top-nav " *ngIf="isLoggedIn()" >
              <ul class="nav pull-right top-menu">
                  <li>
                      <input type="text" class="form-control search" placeholder="Search By Order ID">
                  </li>
                  <li class="dropdown">
                      <a data-toggle="dropdown" class="dropdown-toggle" href="#">
                          <img alt="" src="img/avatar1_small.jpg">
                          <span class="username">{{loggeduser.First}} {{loggeduser.Last}}</span>
                          <b class="caret"></b>
                      </a>
                      <ul class="dropdown-menu extended logout">
                          <div class="log-arrow-up"></div>
                          
                          <li><a href="#"><i class="fa fa-cog"></i> Settings</a></li>
                          <li><a href="#"><i class="fa fa-bell-o"></i> Notification</a></li>
                          <li><a href="login"><i class="fa fa-key"></i> Log Out</a></li>
                      </ul>
                  </li>
              </ul>
          </div> -->
          
      </header>
      